// Locale strings of report 2.5 (account-statement), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "Detailed Account Statement",
  title: "Detailed Account Statement",

  mode_detailed: "Detailed",
  mode_summarized: "Summarized",
  mode_party: "By party",
  mode_entry: "By entry",
  mode_comparative: "Comparative",

  account: "Account",
  includeChildren: "Include sub-accounts",
  partyType: "Party type",
  party: "Party",
  party_captain: "Driver",
  party_center: "Charge center",
  party_business: "Business account",
  party_owner: "Car owner",
  partyMore: "Only the first {limit} results are shown: type part of the name, the phone number or the account code to narrow the search.",
  partyPickerHint: "Search by name, phone, number or account code",
  partyNoResults: "No matching party",
  partyDeleted: "deleted",
  partyNoAccount: "No ledger account",
  partyFailedLoad: "Could not load the parties",
  entryNumber: "Entry number",
  entryNumberHint: "Entry number (JE-...) or internal id",
  periodA: "Current period",
  periodB: "Comparison period",
  periodAFrom: "Current from",
  periodATo: "Current to",
  periodBFrom: "Comparison from",
  periodBTo: "Comparison to",
  groupBy: "Group by",
  month: "Month",
  week: "Week (starts Saturday)",
  movementType: "Movement type",
  allMovements: "All movements",
  amountMin: "Amount from",
  amountMax: "Amount to",
  search: "Search (reference, memo, entry no.)",

  pickAccount: "Pick an account to show its statement",
  pickParty: "Pick a party type and a party",
  pickEntry: "Enter an entry number",

  level: "Level",
  parentAccount: "Parent account",
  normalBalance: "Normal balance",
  yes: "Yes",
  source: "Source",
  event: "Event",
  booking: "Ride",
  createdBy: "Created by",
  system: "System",
  createdAt: "Created at",
  reverseOf: "Reversal of",
  reversedBy: "Reversed by",

  reconciliation: "Reconciliation with the trial balance",
  reconciliationDifference: "difference",
  reconciliationLedger: "ledger balance",
  filteredNotice: "Filtered view: the running balance is the true balance after each line",
  provisional: "Provisional",

  colDate: "Date",
  colEntryNo: "Entry no.",
  colDescription: "Description",
  colReference: "Reference",
  colNature: "Balance side",
  colNotes: "Notes",
  abnormalSuffix: "(abnormal)",

  opening: "Opening balance",
  closing: "Closing balance",
  carriedForward: "Carried forward",
  periodTotal: "Period total",
  filteredTotal: "Total of the shown lines",
  linesWord: "lines",
  rowsTotal: "Movements",
  loadingLines: "Loading movements...",

  accountKind: "Account kind",
  sharedAccount: "shared account - this driver's lines only",
  noPartyAccounts: "No ledger account is linked to this party",
  partyTotal: "Party total",

  movementsCount: "Movements",
  totalDebit: "Total debit",
  totalCredit: "Total credit",
  netMovement: "Net movement",

  item: "Item",
  value: "Value",
  difference: "Difference",
  changePct: "Change %",

  sheetInfo: "Statement info",
  sheetLines: "Movements",
  sheetPartyAccounts: "Party accounts",
};
